<app-content-layout-wrapper>
  <router-outlet></router-outlet>
</app-content-layout-wrapper>
